module.exports = __webpack_public_path__ + "img/Airbnb-Enhanced-Focus-Focused-Breathing.389247b6.jpg";